<template>
  <div class="tiptap-editor">

    <!-- Header -->
    <div v-if="is_inactive" class="header-inactive">
      <div>비활성화된 프로젝트입니다. 노트를 사용하시려면 랩에서 프로젝트를 활성화시키거나 프리미엄 이용권을 구독해주세요.</div>
      <v-btn x-small depressed dark color="#ff5193" class="premium-btn"
        :to="{name: 'signup'}">프리미엄 구독하기</v-btn>
    </div>
    <div v-else class="header" :class="{'header-row': header_row}">
      <div class="header-start">
        <editor-menu-bar v-if="!is_encrypted"
          :editor="editor" v-slot="{ commands, isActive }">
          
          <div class="menubar">
            <div class="tools-15">
              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.bold() }"
                @click="commands.bold">
                <v-icon small>mdi-format-bold</v-icon>
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.italic() }"
                @click="commands.italic">
                <v-icon>mdi-format-italic</v-icon>
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.strike() }"
                @click="commands.strike">
                <v-icon>mdi-format-strikethrough</v-icon>
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.underline() }"
                @click="commands.underline">
                <v-icon>mdi-format-underline</v-icon>
              </button>

              <span class="vertical-line"/>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 1 }) }"
                @click="commands.heading({ level: 1 })">
                H1
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 2 }) }"
                @click="commands.heading({ level: 2 })">
                H2
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                @click="commands.heading({ level: 3 })">
                H3
              </button>

              <span class="vertical-line"/>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.bullet_list() }"
                @click="commands.bullet_list">
                <v-icon>mdi-format-list-bulleted</v-icon>
              </button>

              <button
                class="menubar__button"
                :class="{ 'is-active': isActive.ordered_list() }"
                @click="commands.ordered_list">
                <v-icon>mdi-format-list-numbered</v-icon>
              </button>

              <!-- <span class="vertical-line"/> -->

              <!-- <button
                class="menubar__button"
                :class="{ 'is-active': isActive.blockquote() }"
                @click="commands.blockquote">
                <v-icon>mdi-format-quote-close</v-icon>
              </button> -->

              <!-- <button
                class="menubar__button"
                @click="commands.horizontal_rule">
                <v-icon>mdi-minus</v-icon>
              </button> -->

              <!-- <button
                class="menubar__button"
                @click="showImagePrompt(commands.image)">
                <v-icon>mdi-image</v-icon>
              </button> -->

              <span class="vertical-line"/>

              <button
                class="menubar__button"
                @click="commands.undo">
                <v-icon>mdi-undo</v-icon>
              </button>

              <button
                class="menubar__button"
                @click="commands.redo">
                <v-icon>mdi-redo</v-icon>
              </button>

              <span class="vertical-line"/>

              <button
                class="menubar__button"
                @click="exportDoc(html, title_cab, title);gaClick('project_btn_exportDoc')">
                <v-icon>mdi-format-vertical-align-bottom</v-icon>
              </button>
            </div>
          </div>
        </editor-menu-bar>
      </div>

      <div class="header-end">

        <span v-if="!new_note">
          <span class="saved">새로운 노트를 작성해주세요.</span>
        </span>

        <span v-else-if="saveerror||drafterror">
          <span v-if="saveerror" class="saving">{{ $t('proj_note.save_error') }}</span>
          <span v-else class="saving">{{ $t('proj_note.draft_error') }}</span>
        </span>

        <span v-else-if="!!ing">
          <span class="saving">{{ $t('proj_note.saving_draft') }}</span>
        </span>

        <span v-else-if="!dirty">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="saved" v-on="on">
                {{ $t('proj_note.all_changes_saved') }}
              </span>
            </template>
            <!-- Last modified -->
            <div v-if="!!modifiedts">
              <span>{{ $t('proj_note.last_modified') }}</span>
              <span>{{ modifiedts }}</span>
            </div>
            <!-- Storage -->
            <div>
              <span>{{ $t('proj_note.storage') }}</span>
              <span v-if="!!new_note">{{ notesize }}</span>
              <span v-else>0.0 MB</span>
              <span>/ 2.5 MB</span>
            </div>
          </v-tooltip>
        </span>

        <span v-else>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <span class="ing" v-on="on">
                <span v-if="!editor_focused" class="saving">
                  {{ $t('proj_note.change_not_saved') }}
                </span>
                <span v-else v-on="on" class="saved">
                  {{ $t('proj_note.draft_is_saved') }}
                </span>
              </span>
            </template>
            <!-- Last modified -->
            <div v-if="!!modifiedts">
              <span>{{ $t('proj_note.last_modified') }}</span>
              <span>{{ modifiedts }}</span>
            </div>
            <!-- Storage -->
            <div>
              <span>{{ $t('proj_note.storage') }}</span>
              <span v-if="!!new_note">{{ notesize }}</span>
              <span v-else>0.0 MB</span>
              <span>/ 2.5 MB</span>
            </div>
          </v-tooltip>
        </span>

        <v-btn v-if="!!dirty||drafterror||saveerror"
          small depressed color="primary"
          @click="saveNote()">{{ $t('proj_note.save') }}</v-btn>
        
        <v-btn v-if="!!dirty||drafterror||saveerror"
          small text @click="cancelDraft()">{{ $t('proj_note.cancel') }}</v-btn>

        <!-- <v-btn v-if="!query.doc&&!is_encrypted" small icon
          @click="dialog=true"
          ><v-icon small>lock_open</v-icon></v-btn>
        <v-btn v-if="!query.doc&&is_encrypted" small icon
          @click="dialog=true"
          ><v-icon small>lock</v-icon>
        </v-btn> -->

      </div>
    </div>

    <!-- Contents -->
    <div @click="focusEditor()" class="editor-contents"
      :style="{height: editor_height}">
      <div v-if="!is_encrypted" class="editor scrollbox">
        <!-- <editor-menu-bubble
          class="menububble scrollbox-content" 
          :editor="editor" 
          @hide="hideLinkMenu"
          v-slot="{ commands, isActive, getMarkAttrs, menu }">
          <div class="menububble"
            :class="{ 'is-active': menu.isActive }"
            :style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`">
            
            <form class="menububble__form" v-if="linkMenuIsActive" 
              @submit.prevent="setLinkUrl(commands.link, linkUrl)">
              <input class="menububble__input" 
                type="text" v-model="linkUrl" 
                placeholder="https://" 
                ref="linkInput" 
                @keydown.esc="hideLinkMenu"/>
              <button class="menububble__button" 
                @click="setLinkUrl(commands.link, null)" 
                type="button">
                <v-icon color="white">remove</v-icon>
              </button>
            </form>

            <template v-else>
              <button
                class="menububble__button"
                @click="showLinkMenu(getMarkAttrs('link'))"
                :class="{ 'is-active': isActive.link() }">
                <span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
                <v-icon color="white">link</v-icon>
              </button>
            </template>

          </div>
        </editor-menu-bubble> -->
        
        <!-- Editor -->
        <editor-content class="editor__content scrollbox-content" 
          :editor="editor"/>
      </div>
    </div>


    <!-- Dialog: encrypted -->
    <!-- <v-dialog
      v-model="dialog"
      max-width="290">
      <v-card>
        <template v-if="is_encrypted">
          <v-card-title class="headline">Enter the password</v-card-title>

          <v-card-text>
            <v-text-field
              v-model.lazy="password"
              type="password"
              label="Password"
              @input="error=false"
              @blur="$v.password.$touch()">
            </v-text-field>

            <div class="message-error" v-if="error">
              Please try again.
            </div>
          </v-card-text>

          <v-card-actions>
            <v-btn small text color="red darken-1"
              @click="resetNote()">reset note</v-btn>
            <v-spacer></v-spacer>
            <v-btn small text @click="dialog=false">
              Cancel
            </v-btn>
            <v-btn small depressed color="primary"
              @click="decrypt">
              confirm
            </v-btn>
          </v-card-actions>
        </template>

        <template v-else>
          <v-card-title class="headline">Set the password</v-card-title>

          <v-card-text>
            <v-text-field
              v-model="password"
              label="Password"
              type="password"
              :error-messages="passwordErrors"
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()">
            </v-text-field>

            <v-text-field
              v-model.lazy="password_re"
              label="Re-enter Password"
              type="password"
              :error-messages="passwordReErrors"
              @input="$v.password_re.$touch()"
              @blur="$v.password_re.$touch()">
            </v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text @click="dialog=false">
              Cancel
            </v-btn>
            <v-btn small depressed color="primary"
              @click="setPassword">
              confirm
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>
    </v-dialog> -->

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import CryptoJS from 'crypto-js'
import { required, minLength, maxLength, sameAs } from 'vuelidate/lib/validators'
import { exportDoc } from '../../../custom/function'
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from 'tiptap'
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Italic,
  Image,
  Link,
  Strike,
  Underline,
  History,
  Focus,
  Placeholder,
} from 'tiptap-extensions'

export default {
  components: {
    EditorContent,
    EditorMenuBar,
    EditorMenuBubble,
  },

  props: {
    note: {
      type: String,
    },

    newnote: {
      type: String,
    },

    dirty: {
      type: Number,
    },

    modifiedts: {
      type: String,
    },

    notesize: {
      type: String,
    },

    encrypted: {
      type: Boolean,
    },

    ing: {
      type: Boolean,
    },

    drafterror: {
      type: Boolean,
    },

    saveerror: {
      type: Boolean,
    },
  },

  data() {
    return {
      editor: new Editor({
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Link(),
          new Bold(),
          new Italic(),
          new Image(),
          new Strike(),
          new Underline(),
          new History(),
          new Focus({
            className: 'has-focus',
            nested: true,
          }),
          new Placeholder({
            emptyNodeClass: 'is-empty',
            emptyNodeText: 'Write something …',
            showOnlyWhenEditable: true,
          }),
        ],
        onUpdate: ({ getHTML }) => {
          this.html = getHTML()
          this.$emit('update:ing', true)
        },
      }),
      linkUrl: null,
      linkMenuIsActive: false,

      html: null,
      new_note: null,
      title_cab: 'BT_Project_',

      is_encrypted: this.encrypted,
      // dialog: false,
      // password: "",
      // password_re: "",
      // error: false,

      header_row: true,
      editor_height: 'calc(100vh - 100px)'
    }
  },

  // validations: {
  //   password: {
  //     required,
  //   },

  //   password_re: {
  //     required,
  //     sameAs: sameAs('password')
  //   },
  // },

  computed: {
    query() {
      return this.$route.query
    },

    mode() {
      return this.$route.query.mode
    },

    // passwordErrors() {
    //   const errors = []
    //   if (!this.$v.password.$dirty) return errors
    //   !this.$v.password.required && errors.push('Password is required.')
    //   return errors
    // },

    // passwordReErrors() {
    //   const errors = []
    //   if (!this.$v.password_re.$dirty) return errors
    //   !this.$v.password_re.required && errors.push('Password is required.')
    //   !this.$v.password_re.sameAs && errors.push('Password must be same as upper one.')
    //   return errors
    // },
  },

  created() {
    this.resize()
    window.addEventListener("resize", this.resize)
  },

  mounted() {
    this.updateData()
  },

  beforeDestroy() {
    this.editor.destroy()
  },

  destroyed() {
    window.removeEventListener("resize", this.resize)
  },

  computed: {
    ...mapGetters({
      project_info: 'project/project_info',
    }),

    title() {
      return this.project_info.title
    },

    editor_focused() {
      return this.editor.focused
    },

    is_inactive() {
      return this.project_info.status >= 10
    },
  },

  watch: {
    note: {
      handler(val) {
        this.new_note = val
        this.html = val
        this.$emit('update:newnote', this.new_note)
        if (!!this.editor) { this.editor.setContent(val) }
        // if (this.encrypted&&this.mode=='note') { this.dialog = true }
      },
      immediate: true,
    },

    is_inactive: {
      handler(val) {
        this.editor.setOptions({
          editable: !val
        })
      },
      immediate: true,
    },

    // encrypted: {
    //   handler(val) {
    //     this.is_encrypted = val
    //   },
    //   immediate: true,
    // },

    // dialog(val) {
    //   if (val) {
    //     this.password = ''
    //     this.password_re = ''
    //     this.$v.$reset()
    //     this.error=false
    //   }
    // },
  },

  methods: {

    exportDoc,

    updateData() {
      let vm = this
      setInterval(
        function() {
          if (vm.html != vm.new_note) {
            vm.new_note = vm.html
            vm.$emit('update:newnote', vm.new_note)
          } else {
            vm.$emit('update:ing', false)
          }
        }, 2000
      )
    },

    focusEditor() {
      this.editor.focus()
    },

    // setPassword() {
    //   this.$v.password.$touch()
    //   this.$v.password_re.$touch()
    //   if (!this.$v.password.$anyError && !this.$v.password_re.$anyError) {
    //     try {
    //       let encrypted_text = CryptoJS.AES.encrypt(this.new_note, this.password).toString()
    //       this.$emit('update:encrypted', true)
    //       // this.$emit('update:note', encrypted_text)
    //       this.$emit('update:newnote', encrypted_text)
    //     } finally {
    //       this.dialog = false
    //       this.password = ''
    //       this.password_re = ''
    //     }
    //   }
    // },

    // resetNote() {
    //   try {
    //     this.$emit('update:encrypted', false)
    //     this.$emit('update:note', null)
    //     this.$emit('update:newnote', null)
    //   } finally {
    //     this.dialog = false
    //     this.password = ''
    //     this.password_re = ''
    //   }
    // },

    // decrypt() {
    //   this.$v.password.$touch()
    //   let original_text
    //   if (!this.$v.password.$anyError) {
    //     try {
    //       let bytes  = CryptoJS.AES.decrypt(this.note, this.password)
    //       original_text = bytes.toString(CryptoJS.enc.Utf8)
    //       if (!!original_text.length) {
    //         this.$emit('update:note', original_text)
    //         this.$emit('update:encrypted', false)
    //       } else {
    //         this.error = true
    //       }
    //     } finally {
    //       if (!this.error) { 
    //         this.$emit('update:newnote', original_text)
    //         this.dialog = false 
    //       }
    //     }
    //   }
    // },

    // showImagePrompt(command) {
    //   const src = prompt('Enter the url of your image here')
    //   if (src !== null) {
    //     command({ src })
    //   }
    // },

    // showLinkMenu(attrs) {
    //   this.linkUrl = attrs.href
    //   this.linkMenuIsActive = true
    //   this.$nextTick(() => {
    //     this.$refs.linkInput.focus()
    //   })
    // },

    // hideLinkMenu() {
    //   this.linkUrl = null
    //   this.linkMenuIsActive = false
    // },

    // setLinkUrl(command, url) {
    //   command({ href: url })
    //   this.hideLinkMenu()
    //   this.editor.focus()
    // },

    saveNote() {
      this.$emit('saveNote')
    },

    cancelDraft() {
      this.$emit('cancelDraft')
    },

    resize() {
      this.header_row = window.innerWidth >= 1300 ? true : false
      this.editor_height = window.innerWidth >= 1300 ?
        'calc(100vh - 100px)' : 'calc(100vh - 140px)'
    },

    gaClick(param) {
      this.$analytics.logEvent('click', { name: param })
    },
  },
}
</script>

<style scoped>

  /* Header */

  .header-inactive {
    display: flex;
    flex-direction: row;
    height: 40px;
    padding: 0 24px;
    align-items: center;
  }
  
  .premium-btn {
    margin-left: 12px;
  }

  .header {
    display: flex;
    flex-direction: column;
    padding: 0 24px;
  }

  .header-row {
    flex-direction: row;
    justify-content: space-between;
  }

  .header-end {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    height: 30px;
    margin: 5px 0;
  }

  .header-end span {
    padding-right: 5px;
  }

  .menubar {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .menubar__button {
    padding: 5px;
    font-size: 14px !important;
  }

  .v-icon {
    color: black;
    font-size: 16px !important;
  }

  .saving {
    color: #E0457A;
  }

  .saved {
    color: #BFD833;
  }

  .tools-15 {
    position: relative;
    cursor: pointer;
    height: 30px;
    margin: 5px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 5px;
    background-color: white;
    border-radius: 5px;
  }

  /* Editor */

  .editor-contents {
    border-top: 1px solid #f0f0f0;
    cursor: text;
  }

  .editor {
    height: 100%;
  }

  .editor__content {
    padding: 30px 40px 80px;
  }

  .editor p.is-empty:first-child::before {
    color: gray;
    float: left;
    pointer-events: none;
    height: 0;
    font-style: italic;
    content: attr(data-empty-text);
  }

  .menububble {
    position: absolute;
    display: flex;
    z-index: 20;
    background: black;
    border-radius: 5px;
    padding: 0.3rem;
    margin-bottom: 0.5rem;
    transform: translateX(-50%);
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
  }

  .menububble.is-active {
    opacity: 1;
    visibility: visible;
  }

  .menububble__button {
    display: inline-flex;
    background: transparent;
    border: 0;
    color: white;
    padding: 0.2rem 0.5rem;
    margin-right: 0.2rem;
    border-radius: 3px;
    cursor: pointer;
  }

  .menububble__button:last-child {
    margin-right: 0;
  }

  .menububble__button:hover {
    background-color: rgba(white, 0.1);
  }

  .menububble__button:is-active {
    background-color: rgba(white, 0.2);
  }

  .menububble:last-child {
    margin-right: 0;
  }

  .menububble__form {
    display: flex;
    align-items: center;
  }

  .menububble__input {
    font: inherit;
    border: none;
    background: transparent;
    color: white;
  }

</style>


// WEBPACK FOOTER //
// src/components/shared_components/editor/Tiptap.vue